import service from '@/utils/server';

const modName = '/md/materielLq/';

// 分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

// 新增
export const addData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

// 修改
export const updateData = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};

// 删除
export const deleteData = data => {
  return service({
    url: modName + 'delete/' + data.id,
    method: 'post'
  });
};

// 模板下载
export const downtemplate = data => {
  let config = {
    timeout: 500000,
    responseType: 'blob'
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

// 批量导入
export const uploadMaterielLq = data => {
  let config = {
    timeout: 500000,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'blob'
  };
  return service({
    ...config,
    url: modName + 'import',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/materielLq/api/index.js